import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { Link, withRouter } from 'react-router-dom'
import { rgba } from 'polished'
import { find } from 'lodash'
import { Save, ImageReferenceSlideshow } from '../../components'

import { updateSettings } from '../../settings'
import { fetchFavourites, getFavourites } from './redux'
import { fetchMedia, getMedia } from '../../media'
import { fetchChapters, getChapters } from '../Chapters/redux'
import { fetchReferences, getReferences } from '../ImageReferences/redux';

import { isClient } from '../../utils'
import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding, bgImage } from '../../styles/global';

let FadeImage;

if (isClient()) {
    FadeImage = require('react-fade-image').default;
}


class Favourites extends Component {

    state = {

    }

    static fetchData(store, match) {
        return store.dispatch(fetchFavourites()); 
    }

    componentDidMount = () => {
        const { updateSettings, fetchFavourites, fetchChapters, fetchMedia, fetchReferences } = this.props;

        fetchReferences()
        fetchFavourites()
        fetchMedia()

        updateSettings({
            pageTitle: 'Favourites'
        })
    }

    getSectionTitle = (parentID) => {
        const { chapters } = this.props;
        const parent = find(chapters.data, {id: parentID});

        if (parent) {
            return parent.title
        }
    }
    
    renderDocuments = () => {
        const { favourites, chapters } = this.props;

        if (favourites.documents && favourites.documents.length) {
            const savedPages = favourites.documents.map((pageID, i) => {
                const page = find(chapters.data, {id: pageID});
                if (page) {
                    const parent = find(chapters.data, {id: page.parent_id});     
                    let link = `/chapter/${page.slug}`
                    if(parent.slug){
                        link = `/chapter/${parent.slug}/${page.slug}`
                    }
                    return(
                        <Page
                            key={i}
                            to={link}
                        >
                            <Section>{this.getSectionTitle(page.parent_id)} /</Section>
                            {page.title}
                        </Page>
                    )   
                }             
            })

            return (
                <FavouritesGroup
                    type={'pages'}
                >
                    <Title>Saved Pages</Title> 
                    <PageFavourites>{savedPages}</PageFavourites>
                </FavouritesGroup>
            )
        }
    }
    
    // returnImageReferences = () => {
    //     const { favourites, chapters, references } = this.props;
    //     if (favourites.imageReferences.length && references && references.data) {
    //         return favourites.images.map((imageID, i) => {
    //             const image = find(references.data.refs.items, {post: { ID: imageID } })

    //             if (image) {    
    //                 const src = `${image.path}${image.meta.sizes.medium.file}`;
    //                 const placeholder = (
    //                     <ImageFavourite>
    
    //                         <Image
    //                             image={ref.images[0].thumbnail}
    //                         />
                            
    //                         <Info>
    //                             Aesop {ref.store.name} {ref.year} ({ref.category.name})
    //                             <br/>
    //                             {ref.caption}
    //                         </Info>
                            
    //                     </ImageFavourite>
    //                 )
    
    //                 return (
    //                     <SlideshowModal 
    //                         key={index}
    //                         imageReference={true}
    //                         images={ref.images}
    //                         tags={ref.tags}
    //                         caption={ref.caption}
    //                         placeholder={placeholder}
    //                     />
    //                 )
    //             }
    //         })
    //     }
    // }

    returnImages = () => {
        const { favourites, chapters, media } = this.props;

        if (favourites.images.length && media && media.data) {

            return favourites.images.map((imageID, i) => {
                const image = find(media.data.data, {post: { ID: imageID } })

                if (image) {    
                    const src = `${image.path}${image.meta.sizes.medium_large.file}`;
                    return (
                        <ImageFavourite
                            key={i}
                        >

                            {/* 
                            <SaveWrapper>
                                <Save
                                    white={true}
                                    type={'image'}
                                    id={imageID}
                                />
                            </SaveWrapper> 
                            */}
                            
                            <Image
                                image={src}
                            />
                        </ImageFavourite>
                    )
                }
            })
        }
    }

    renderImageFavourites = () => {
        const { favourites, chapters, media } = this.props;

        if (media && favourites.images.length || favourites.imageReferences.length) {
            return (
                <FavouritesGroup
                    type={'images'}
                >
                    <Title>Images</Title> 
                    <Grid>
                        {this.returnImages()}
                        {/* {this.returnImageReferences()} */}
                    </Grid>
                </FavouritesGroup>
            )
        }
    }
      
    render() {
        return (
            <Container>
                {this.renderDocuments()}
                {this.renderImageFavourites()}
            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 65px); 
    color: red;
`

const SaveWrapper = styled.div``
const Title = styled.div``

const FavouritesGroup = styled.div`
    display: flex;
    ${padding}
    padding-top: 25px;
    padding-bottom: 80px;
    flex: 0 1 auto;
    
    &:not(:last-child) {
        border-bottom: 1px solid black;
    }

    ${Title} {
        font-size: 24px;
    }

    ${props => {
        if (props.type == 'pages') return css`
            ${Title} {
                flex: 0 1 240px;
                font-size: 24px;
            }

            ${media.phone`
                flex: 0 1 auto;
                flex-direction: column;
                padding-bottom: 24px;

                ${Title} {
                    flex: 0 1 auto;
                    margin-bottom: 4px;
                    font-size: 22px !important;
                }
            `}
        `

        if (props.type == 'images') return css`
                flex-direction: column;
        `
    }}
`

const Grid = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: calc(100% + 17px);
    padding: 13px 0;
    box-sizing: border-box;
    flex: 1 0 auto;
    margin-top: 18px;

    > * {
        display: flex;
        flex-direction: column;
        flex: 0 1;
        flex-basis: calc(33.3% - 17px);
        margin-right: 17px;
        margin-bottom: 17px;

        ${media.tablet`
            flex-basis: calc(50% - 17px);
            margin-bottom: 30px;
        `}

        ${media.phone`
            flex-basis: calc(100% - 17px);
            margin-bottom: 30px;
        `}
    }
`

// Pages

const PageFavourites = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    .bold {
        background: none;
        font-weight: bold;
    }
`

const Page = styled(Link)`
    display: flex;
    font-size: 24px;
    padding: 10px 0;

    ${media.phone`
        font-size: 16px;
    `}
`

const Section = styled.div`
    color: #9C9B8F;
    margin-right: 6px;
`

// Images

const ImageFavourite = styled.div`
    position: relative;

    ${SaveWrapper} {
        position: absolute;
        top: 16px;
        left: 16px;
    }
`

const Image = styled.div`
    width: 100%;
    height: 224px;
    ${bgImage}   
    background-image: url(${props => props.image});
`

const Info = styled.div`
    font-size: 16px;
    color: #000000;  
    margin-top: 7px;
`


const mapDispatchToProps = dispatch => ({
    fetchFavourites() {
        dispatch(fetchFavourites())
    },
    fetchMedia() {
        dispatch(fetchMedia())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
    fetchReferences() {
        dispatch(fetchReferences())
    },
})

const mapStateToProps = (state, props) => ({
    favourites: getFavourites(state),
    chapters: getChapters(state),
    media: getMedia(state),
    references: getReferences(state)
})


export default connect(mapStateToProps, mapDispatchToProps)(Favourites);



// WEBPACK FOOTER //
// ./client/modules/Favourites/Favourites.js